"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ThemeImage;
const React = require("react");
const ThemeContext_1 = require("../Contexts/ThemeContext");
function ThemeImage({ className, imgLight, imgDark, alt, title }) {
    const { theme } = (0, ThemeContext_1.useThemeContext)();
    return (React.createElement("img", { className: className, src: theme === 'dark' ? (imgDark ?? imgLight) : imgLight, alt: alt, title: title, loading: "lazy" }));
}
